import { SUPPORTED_COUNTRY } from "@shared-kernel/domain/types/supported-country";
import type { AddressLookup } from "@shared-kernel/domain/types/address-lookup";
import type { OnboardProviderBody } from "@shared-kernel/application/ports/shared/shared-repository";
import { normalizeIban, normalizeIdentifier, normalizeSiret } from "@utils/formatting";

// ============================================================================
// Step IDs Enum
// ============================================================================

export enum ONBOARDING_STEP {
  FORM = 0,
  RECAP = 1,
}

// ============================================================================
// Default Values
// ============================================================================

const emptyAddress: AddressLookup = { placeId: "", description: "", sessionToken: "", invalid: false };

export const defaultValues = {
  name: "",
  legalRepresentativeFirstName: "",
  legalRepresentativeLastName: "",
  siret: "",
  activityRegistrationNumber: "",
  iban: "",
  postalAddress: emptyAddress,
  addressComplement: "",
  country: SUPPORTED_COUNTRY.FRANCE,
};

// ============================================================================
// Formatter Function (converts form data to API body)
// ============================================================================

export const formatFormDataToOnboardProviderBody = (data: {
  name: string;
  legalRepresentativeFirstName: string;
  legalRepresentativeLastName: string;
  siret: string;
  activityRegistrationNumber: string;
  iban: string;
  postalAddress: AddressLookup;
  country: SUPPORTED_COUNTRY;
  addressComplement: string;
}): OnboardProviderBody => {
  return {
    name: data.name,
    iban: normalizeIban(data.iban),
    siret: normalizeSiret(data.siret, data.country),
    activityRegistrationNumber: normalizeIdentifier(data.activityRegistrationNumber) || null,
    legalRepresentativeFirstName: data.legalRepresentativeFirstName,
    legalRepresentativeLastName: data.legalRepresentativeLastName,
    postalAddress: data.postalAddress,
    addressComplement: data.addressComplement ? data.addressComplement : null,
  };
};
